export { default } from './Menu.component';
